import { render, staticRenderFns } from "./DraggableTreeviewNode.vue?vue&type=template&id=fc61fa9c&"
import script from "./DraggableTreeviewNode.vue?vue&type=script&lang=ts&"
export * from "./DraggableTreeviewNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports